<template>
  <div class="container">
    <div class="row">
      <div class="col-md-12">
        <div class="faqs-container">
          <div
            id="accordion"
            class="panel-group"
            role="tablist"
            aria-multiselectable="true"
            @click="updateButtonStatus()"
          >
            <div v-for="(faq, index) in faqData.faqlist" :key="faq.question" class="panel">
              <div :id="'heading' + index" class="panel-heading" role="tab">
                <h4
                  role="button"
                  data-toggle="collapse"
                  data-parent="#accordion"
                  :href="'#collapse' + index"
                  :aria-expanded="index < 1 ? true : false"
                  :aria-controls="'collapse' + index"
                >
                  <span>{{ index + 1 }}.</span>{{ faq.question }}
                </h4>
              </div>
              <div
                :id="'collapse' + index"
                class="panel-collapse collapse"
                :class="index < 1 ? 'in' : ''"
                role="tabpanel"
                :aria-labelledby="heading + index"
              >
                <div class="panel-body">
                  <div class="row">
                    <p class="col-md-8" v-html="faq.answer"></p>
                    <div v-if="faq.image" class="col-md-4 hidden-xs">
                      <img :src="faq.image" alt="" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="view-container hidden-xs" @click="toggleViewAll()">
            <button v-if="viewAll">{{ faqData.closeanswers }}</button>
            <button v-else>{{ faqData.viewanswers }}</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'mixa-faq',
  props: {
    faqData: {
      type: Object,
      required: true,
    },
    heading: { types: String, require: true },
  },
  data() {
    return {
      viewAll: false,
      listClass: '',
      panelClass: '',
    };
  },
  mounted() {
    this.listClass = document.getElementsByClassName('panel-collapse collapse');
    this.panelClass = document.querySelectorAll('.panel-heading');
  },
  methods: {
    updateButtonStatus() {
      var collapsedDiv = document.getElementsByClassName('collapsed');
      if (collapsedDiv.length === this.faqData.faqlist.length - 1) this.viewAll = false;
    },
    toggleViewAll() {
      this.viewAll = !this.viewAll;
      if (this.viewAll) {
        for (let i = 0; i < this.listClass.length; i++) {
          this.listClass[i].removeAttribute('style');
          this.listClass[i].classList.add('in');
          this.panelClass[i].querySelector('h4').classList.remove('collapsed');
          this.panelClass[i].querySelector('h4').style.color = '#026DC2';
        }
      } else {
        for (let i = 1; i < this.listClass.length; i++) {
          this.listClass[i].classList.remove('in');
          this.panelClass[i].querySelector('h4').classList.add('collapsed');
        }
      }
    },
  },
};
</script>
